<!--
	Copyright 2023 HALBY
	See LICENSE file for details.
 -->

<script lang="ts">
	import { page } from "$app/stores";
	import { getMaruFont } from "$lib/services/font-service";
    import { createEventDispatcher, onMount } from "svelte";
	import { getLang } from '$lib/translations/translations';

	export let link = '';
	export let newWindow = false;
	export let arrow = false;
	export let type: 'button' | 'submit' | 'reset' = 'button';
	export let size: 'small' | 'medium' | 'large';
	export let style: 'solid' | 'outline' = 'solid';
	export let testId = '';
	export let name = '';
	export let className: string | undefined =  '';

	let target = '';
	$: if (newWindow || link.includes('http')) {
		target = '_blank';
	} else {
		target = '';
	}

    const dispatch = createEventDispatcher();

    function handleClick() {
        dispatch('click');
    }

	let maru_font: string | null = null;
	onMount(() => {
		maru_font = getMaruFont($page.url);
	});

	$: lang = getLang($page.url).value ?? 'ja';
</script>

{#if link !== ''}
    <a class="btn {size} {style} outline-2" data-testid={testId} href={link} {target}>
        <p class="{maru_font} font-bold {className} {lang === 'ja' ? 'translate-y-[-2px]' : ''}">
            <slot />
            {#if arrow}
                <i class="fa-solid fa-arrow-right" />
            {/if}
        </p>
    </a>
{:else}
    <button {type} aria-label="{type}" data-testid={testId} {name} class="btn {size} {style} outline-2" on:click={handleClick}>
        <p class="{maru_font} font-bold {className}">
            <slot />
            {#if arrow}
                <i class="fa-solid fa-arrow-right" />
            {/if}
        </p>
    </button>
{/if}

<style lang="scss">
	@use '$lib/assets/css/variables' as var;

	.btn {
		text-decoration: none;
		color: white;
		background-color: var.$color-dark-brown;
		border-radius: 9999px;
        cursor: pointer;
		@include var.hover-lighter-strong;
	}
	.btn.small {
		font-size: 18px;
		padding: 5px 15px;
		i {
			font-size: 15px;
		}
	}
	.btn.medium {
		font-size: 20px;
		padding: 7px 20px;
		min-width: 266px;
		i {
			font-size: 16px;
		}
	}
	.btn.large {
		font-size: 22px;
		padding: 9px 52px;
		min-width: 266px;
		display: flex;
		justify-content: center;
		i {
			font-size: 18px;
		}
	}
	.btn.outline {
		background-color: white;
		// border: 2px solid var.$color-dark-brown;
		color: var.$color-dark-brown;
	}
	p {
		text-align: center;
	}
</style>
